import { FilterType } from './filterType';
import { addTermToFilter } from 'Js/utils/devExtremeSearchUtils';
import { LogicalOperator } from 'Js/types/logicalOperator';
import VarType from 'Js/enums/varType.js';
import { dateFormatDayTechnical } from 'Js/utils/dateFormat';
import { FilterButtonType } from '../types/filterButtonType';
import { logicalOperator } from 'Js/utils/logicalOperator';
export default class Filter {
    value;
    resetValue;
    filterButtonType;
    filterType;
    resetFilterType;
    dataField;
    multipleFilterOperator;
    createFilterValue;
    createFilter;
    label;
    inputId;
    apiUrl;
    property;
    filterProperty;
    searchExpression;
    searchValue;
    selectExpression;
    itemValue;
    displayExpression;
    group;
    hideNullValues;
    useContains;
    itemsPerPage;
    combine;
    combineWith;
    addToFilterExpression;
    isGetParam;
    allowNull;
    allowLike;
    allowedDates;
    /**
     * @param {FilterOptions} options
     */
    constructor(options = {}) {
        const { value = undefined, resetValue = undefined, filterType = undefined, filterButtonType = FilterButtonType.Input, resetFilterType = undefined, dataField = undefined, multipleFilterOperator = LogicalOperator.Or, createFilterValue = undefined, createFilter = undefined, label = undefined, inputId = undefined, apiUrl = undefined, property = undefined, filterProperty = undefined, searchExpression = undefined, searchValue = undefined, selectExpression = undefined, itemValue = undefined, displayExpression = undefined, group = undefined, hideNullValues = false, useContains = false, itemsPerPage = 10, combine = true, combineWith = LogicalOperator.And, addToFilterExpression = true, isGetParam = false, allowNull = false, allowLike = false, allowedDates = undefined, } = options;
        this.value = value;
        // reset to null is possible
        this.resetValue = resetValue !== undefined ? resetValue : allowNull ? value : resetValue;
        this.filterButtonType = filterButtonType;
        this.filterType = filterType !== undefined ? filterType : FilterType.Equal;
        this.resetFilterType = resetFilterType !== undefined ? resetFilterType : filterType;
        this.dataField = dataField;
        this.createFilterValue = createFilterValue;
        this.createFilter = createFilter;
        this.multipleFilterOperator = multipleFilterOperator;
        this.label = label;
        this.inputId = inputId;
        this.apiUrl = apiUrl;
        this.property = property;
        this.filterProperty = filterProperty;
        this.searchExpression = searchExpression;
        this.searchValue = searchValue;
        this.selectExpression = selectExpression;
        this.itemValue = itemValue;
        this.displayExpression = displayExpression;
        this.group = group;
        this.hideNullValues = hideNullValues;
        this.useContains = useContains;
        this.itemsPerPage = itemsPerPage;
        this.combine = combine;
        this.combineWith = combineWith;
        this.addToFilterExpression = addToFilterExpression;
        this.isGetParam = isGetParam;
        this.allowNull = allowNull;
        this.allowLike = allowLike;
        this.allowedDates = allowedDates;
    }
    static from(object) {
        return Object.assign(new Filter({}), object);
    }
    /**
     * Sets filter and filterType to reset values.
     */
    reset() {
        this.value = this.resetValue;
        this.filterType = this.resetFilterType;
    }
    /**
     * Sets filter value.
     */
    setValue(value, filterType) {
        this.value = value;
        this.filterType = filterType;
    }
    /**
     * Returns filter value calling createFilterValue if present.
     * If not present simply returns value.
     */
    getFilterValue() {
        return this.createFilterValue ? this.createFilterValue(this.value) : this.value;
    }
    /**
     * Returns whether filter should be added to filterExpression (true) or not (false).
     * Conditions for returning true:
     *  - getFilterValue returns truthy value or returned value is 0 or returned value is of type boolean or createFilter is present
     *  - addToFilterExpression is true
     */
    shouldAddFilterToExpression() {
        const filterValue = this.getFilterValue();
        return (filterValue || filterValue === 0 || typeof filterValue === 'boolean' || this.createFilter || (filterValue === null && this.allowNull)) && this.addToFilterExpression;
    }
    /**
     * Returns a devextreme style filter.
     */
    getDevExtremeStyleFilter() {
        this.filterType ??= FilterType.Equal;
        if (this.createFilter) {
            return this.createFilter(this.value, this.dataField, this.filterType);
        }
        const hasMultipleDataFields = Array.isArray(this.dataField);
        let filterValue = this.getFilterValue();
        if (this.filterType === FilterType.Like) {
            filterValue = `%${filterValue.replaceAll(' ', '%')}%`;
        }
        try {
            // We support an array as a value. Thus, we should build them with 'or' clause
            const arrayValue = filterValue;
            if (Array.isArray(arrayValue)) {
                const filters = [];
                arrayValue.forEach(val => {
                    filters.push([this.dataField, this.filterType, val]);
                    filters.push(this.multipleFilterOperator ?? logicalOperator.OR);
                });
                filters.pop();
                return filters;
            }
        }
        catch (_) {
            //Skip silently
        }
        // Because of timezone vue somehow builds date with -1/-2 hours.
        if (typeof (filterValue) === VarType.Object) {
            try {
                filterValue = dateFormatDayTechnical(filterValue);
            }
            catch (e) {
                console.log('error parsing date', e);
            }
        }
        if (hasMultipleDataFields && Array.isArray(this.dataField)) {
            const subFilters = [];
            this.dataField.forEach((dataField) => {
                const combinedDataField = this.property ? `${dataField}.${this.property}` : dataField;
                addTermToFilter(subFilters, [combinedDataField, this.filterType, filterValue], this.multipleFilterOperator ?? logicalOperator.OR);
            });
            return subFilters;
        }
        const combinedDataField = this.property ? `${this.dataField}.${this.property}` : this.dataField;
        return [combinedDataField, this.filterType, filterValue];
    }
}
